import { render, staticRenderFns } from "./AddProgram.vue?vue&type=template&id=61686866&scoped=true"
import script from "./AddProgram.vue?vue&type=script&lang=js"
export * from "./AddProgram.vue?vue&type=script&lang=js"
import style0 from "./AddProgram.vue?vue&type=style&index=0&id=61686866&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61686866",
  null
  
)

export default component.exports